"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONSTRUCTION_INVOICE_STATUSES = void 0;
exports.CONSTRUCTION_INVOICE_STATUSES = {
    APPROVED: 'approved',
    CANCELED: 'canceled',
    SUBMITTED: 'submitted',
    UPLOADED: 'uploaded'
};
